import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core';
import Header from "src/components/Header";

const useStyles = makeStyles(() => ({
  valoresList: {
    listStyle: "none",
    padding: 0,
    margin: "4px 0 0",
  },
  valorItem: {
    position: "relative",
    padding: "3px 0 3px 15px",
    "&::before": {
      content: "'•'", // Mismo punto que las listas de Documentaciones
      position: "absolute",
      left: "0",
      color: "#900533",
      fontWeight: "bold",
    },
  },
}));

const VALORES = [
  "Responsabilidad",
  "Respeto",
  "Compromiso",
  "Vocación de servicio",
  "Honestidad",
  "Disciplina",
  "Confidencialidad",
];


const Nosotros: React.FC = () => {
  const classes = useStyles();

  return (
    <IonPage>
      <Header titulo="Sobre Nosotros" />

      <IonContent id="nosotros">
        <div className="container mb-3">
          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>Política de Calidad</cite>
              </figcaption>

              <blockquote>
                <p className="mt-1 mb-0">
                  Es nuestro compromiso satisfacer las necesidades de los
                  clientes, ofreciendo servicios que cumplan con los
                  requerimientos y especificaciones acordados, trabajando con
                  eficiencia y productividad, con un enfoque de Mejora Continua
                  y Responsabilidad Social Empresarial cumpliendo los requisitos
                  aplicables.
                </p>
              </blockquote>
            </figure>
          </div>

          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>Misión</cite>
              </figcaption>

              <blockquote>
                <p className="mt-1 mb-0">
                  Brindar servicios especializados con responsabilidad social,
                  enfoque profesional, procesos estandarizados y colaboradores
                  eficientes, formados en principios y valores.
                </p>
              </blockquote>
            </figure>
          </div>

          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>Visión</cite>
              </figcaption>

              <blockquote>
                <p className="mt-1 mb-0">
                  Liderar siendo el mejor en el sector de servicios generales,
                  con fuerte especialización en limpieza.
                </p>
              </blockquote>
            </figure>
          </div>

          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>Valores</cite>
              </figcaption>

              <blockquote>
                <ul className={classes.valoresList}>
                  {VALORES.map((valor) => (
                    <li key={valor} className={classes.valorItem}>
                      {valor}
                    </li>
                  ))}
                </ul>
              </blockquote>
            </figure>
          </div>

        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Nosotros);
